import * as THREE from "three";

const light = new THREE.AmbientLight( 0x404040 ); // soft white light
const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
light.add( directionalLight );
directionalLight.position.set(5,5,5);

//sombra
//directionalLight.castShadow = true; // default false
//directionalLight.shadow.mapSize.width = 512; // default
//directionalLight.shadow.mapSize.height = 512; // default
//directionalLight.shadow.camera.near = 0.5; // default
//directionalLight.shadow.camera.far = 500; // default

//ayuda a ver el generador de sombra
//const helper = new THREE.CameraHelper( directionalLight.shadow.camera );
//light.add(helper);
export default light;